import { Box, IconButton, InputAdornment, TextField } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { default as React, useEffect, useState } from 'react';
import PropTypes from 'prop-types'

var timeout;

function Search(props) {
  const [hasError, setHasError] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [searchedData, setSearchedData] = useState([])
  const [originalData, setOriginalData] = useState([])

  const timeoutValue = 300

  useEffect(() => {
    setSearchedData(props.data)
    setOriginalData(props.data)
    setSearchValue("")
  }, [props.data])


  function deepValue(obj, path) {
    for (var i = 0, path = path.split('.'), len = path.length; i < len; i++) {
      if (Array.isArray(obj[path[i]])) {
        // alert(i + ":" + path[i + 1]);
        obj = obj[path[i]][path[i + 1]];
        i++;

      } else {
        obj = obj[path[i]];
      }

    };
    return obj;
  };

  function search(searchText) {
    const text = searchText.toLowerCase();

    if (text === "") {
      setSearchedData(originalData)
    }

    const foundData = originalData.filter(data => {
      var match = false

      const searchField = deepValue(data, props.searchField)
      if (searchField != null) {
        if (searchField.toLowerCase().includes(text) == true) {
          return true
        }
      }

      if (props.secondaryFields != null && props.secondaryFields.length > 0) {
        props.secondaryFields.forEach(field => {
          const fieldValue = deepValue(data, field)
          if (fieldValue != null) {
            if (fieldValue.toLowerCase().includes(text) === true) {
              match = true
            }
          }
        });
        return match
      }

      return false

    });

    setSearchedData(foundData)
    setSearchValue(searchText)

    props.returnSearchMatches(foundData);
  }


  function handleSearch(event) {
    if (timeout != null) {
      clearTimeout(timeout)
    };

    setSearchValue(event.target.value)

    timeout = setTimeout((value) => {
      props.searchFunction != null ? props.searchFunction.then != null ? props.searchFunction(value, true).then() : props.searchFunction(value, true) : search(value)
    }, timeoutValue, event.target.value);
  }

  function clearSearch() {
    setSearchValue("")
    props.searchFunction != null ? props.searchFunction.then != null ? props.searchFunction("").then() : props.searchFunction("") : search("")
  }


  return (
    <Box>
      <TextField
        fullWidth
        id="outlined-name"
        label={props.searchTitle}
        value={searchValue}
        onChange={handleSearch}
        variant="outlined"
        margin="dense"
        InputProps={
          searchValue === "" ? null :
            {
              endAdornment:
                <InputAdornment position="end" >
                  <IconButton
                    onClick={clearSearch}
                  >
                    <CancelIcon />
                  </IconButton>
                </InputAdornment>
            }
        }
      />
    </Box>
  )
}

Search.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  searchField: PropTypes.string,
  secondaryFields: PropTypes.arrayOf(PropTypes.string),
  searchFunction: PropTypes.func,
  searchTitle: PropTypes.string,
  returnSearchMatches: function (props, propName, componentName) {
    if ((props['searchFunction'] == undefined && (props[propName] == undefined || typeof (props[propName]) != 'function'))) {
      return new Error('Please provide a returnSearchMatches function!');
    }
  },
}



export default React.memo(Search);
